export const getSelectedAdditionalServices = (
  additionalServices,
  weeksQuantity,
  hasSelectedAccommodation
) =>
  additionalServices
    .filter((as) => as.fromWeeks === null || as.fromWeeks <= weeksQuantity)
    .filter((as) => (as.hasAccommodation ? hasSelectedAccommodation : true))
    .filter((as) => as.required || as.selected);

export const additionalServicesTotalPrices = (
  additionalServices,
  insurances,
  courseWeekQuantity,
  exchangeRate
) => {
  let price = 0;
  let priceExchanged = 0;

  const additionalPrice = SumAdditionalService(additionalServices);
  const insurancePrice = SumInsurancePrice(insurances, courseWeekQuantity);

  priceExchanged += insurancePrice + additionalPrice;

  if (exchangeRate > 0) price = priceExchanged / exchangeRate;

  return {
    total: price,
    totalExchanged: priceExchanged,
  };
};

export const getSelectedServicesIds = (
  services,
  weeksQuantity,
  hasSelectedAccommodation
) => {
  const additionalArray = [];

  services
    .filter((b) => !b.title.includes('OSHC'))
    .filter((as) => as.fromWeeks === null || as.fromWeeks <= weeksQuantity)
    .filter((as) => (as.hasAccommodation ? hasSelectedAccommodation : true))
    .forEach((a) => {
      if (a.id === 0 && !a.selected) {
        // se o adiconal tiver id === 0 segnifica que veio de um recurso externo
        // atualmente esse tipo de serviço é obrigatório
        throw new Error(
          `Serviço adicional: ${a.title} é obrigatório. Volte na aba de 'Serviços Adicionais' e selecione o serviço para continuar.`
        );
      } else if (a.id !== 0 && (a.selected || a.required)) {
        additionalArray.push({ id: a.id });
      }
    });

  return additionalArray;
};

export const getSelectedOshc = (oshcs) => {
  const oshcArray = [];

  oshcs
    .filter((b) => b.title.includes('(OSHC)'))
    .forEach((c) => {
      oshcArray.push(c);
    });

  if (!oshcArray[0]?.selected && oshcArray.length > 0) {
    throw new Error(
      `Serviço adicional: (OSHC) é obrigatório. Volte na aba de 'Serviços Adicionais' e selecione o serviço para continuar.`
    );
  }

  return oshcArray;
};

export const SumAdditionalService = (additionalServices) => {
  let additionalPrice = 0;

  if (additionalServices && additionalServices.length)
    additionalServices.forEach((d) => {
      additionalPrice += d.priceExchanged;
    });

  return additionalPrice;
};

export const SumInsurancePrice = (
  insurances,
  courseWeekQuantity,
  isPriceFrom = false
) => {
  let insurancePrices = 0;

  if (insurances.length) {
    if (!isPriceFrom) {
      insurances.forEach((insurance) => {
        insurancePrices +=
          insurance.grossPriceExchanged * (courseWeekQuantity * 7 + 4);
      });
    } else {
      insurances.forEach((insurance) => {
        insurancePrices +=
          insurance.priceFromExchanged * (courseWeekQuantity * 7 + 4);
      });
    }
  }

  return insurancePrices;
};

export const UnsetAccommodationAdditional = (additionals) => {
  additionals.forEach((additional) => {
    if (additional.hasAccommodation) {
      additional.selected = false;
    }
  });
  return additionals;
};
